import { Button, Col, Form, Row, Select, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { calculateAvgTcmTreatmentCostAsync } from '../InsuranceContorlSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { tcmAverageParams } from '../../../../services/echarts'
import moment from 'moment'
import { DateTimeFormat, DateTimeFormatSimple } from '../../../../models/datetime'
import styles from '../insuranceContorl.module.css'
import { getFullDoctorList, selectDoctors } from '../../../registration/list/registrationSlice'
import { DateRangeType, DateSelect, TJFXTime, getDateRange } from '../../../../compnents/form/DateSelect'
import { selectInsuranceArray } from '../../../../app/applicationSlice'

export const TcmAverageStatistics = () => {
  const [form] = Form.useForm()
  const { Option } = Select
  const dispatch = useDispatch<RootDispatch>()

  const [tableData, setTableData] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  const doctors = useSelector(selectDoctors)
  const insuranceArray = useSelector(selectInsuranceArray)

  useEffect(() => {
    dispatch(getFullDoctorList())
    // 设置默认值
    form.setFieldsValue({
      yidibz: 'all',
    })
    // 组件挂载时自动查询本月数据
    const [head, tail] = getDateRange(DateRangeType.ThisMonth)
    const params: tcmAverageParams = {
      startTime: head ? moment(head).format(DateTimeFormatSimple) + ' 00:00:00' : '',
      endTime: tail ? moment(tail).format(DateTimeFormatSimple) + ' 23:59:59' : '',
    }

    setLoading(true)
    dispatch(calculateAvgTcmTreatmentCostAsync(params))
      .then(unwrapResult)
      .then((res: any) => {
        setTableData(Array.isArray(res) ? res : [])
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  const handleQuery = (values?: any) => {
    const formValues = values || form.getFieldsValue()
    let startTime = ''
    let endTime = ''

    // 如果选择的是自选范围（Range），使用用户选择的时间
    if (formValues?._dateRange === DateRangeType.Range) {
      startTime = formValues?.timeHead
        ? moment(formValues.timeHead).format(DateTimeFormatSimple) + ' 00:00:00'
        : ''
      endTime = formValues?.timeTail
        ? moment(formValues.timeTail).format(DateTimeFormatSimple) + ' 23:59:59'
        : ''
    } else if (formValues?._dateRange !== undefined) {
      // 如果是预设的日期范围（今天、本周、本月等），使用 getDateRange 计算
      const [head, tail] = getDateRange(formValues._dateRange)
      startTime = head ? moment(head).format(DateTimeFormatSimple) + ' 00:00:00' : ''
      endTime = tail ? moment(tail).format(DateTimeFormatSimple) + ' 23:59:59' : ''
    }

    const params: tcmAverageParams = {
      doctorId: formValues?.doctorId,
      yidibz: formValues?.yidibz === 'all' ? undefined : formValues?.yidibz,
      startTime,
      endTime,
    }

    setLoading(true)
    dispatch(calculateAvgTcmTreatmentCostAsync(params))
      .then(unwrapResult)
      .then((res: any) => {
        setTableData(Array.isArray(res) ? res : [])
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const columns = [
    {
      title: '日期',
      dataIndex: 'monthlyDate',
      key: 'monthlyDate',
      width: 150,
    },
    {
      title: '人头',
      dataIndex: 'headNumber',
      key: 'headNumber',
      width: 120,
      render: (text: any) => text || 0,
    },
    {
      title: '列支',
      dataIndex: 'totalLz',
      key: 'totalLz',
      width: 150,
      render: (text: any) => (text ? `¥${Number(text).toFixed(2)}` : '¥0.00'),
    },
    {
      title: '人均',
      dataIndex: 'perCapita',
      key: 'perCapita',
      width: 150,
      render: (text: any) => (text ? `¥${Number(text).toFixed(2)}` : '¥0.00'),
    },
  ]

  return (
    <div className={styles.stacked}>
      <Form form={form} onFinish={handleQuery} initialValues={{ yidibz: 'all' }}>
        <Row gutter={12}>
          <Col span={3}>
            <Form.Item name='doctorId'>
              <Select placeholder='请选择接诊医生' allowClear>
                {doctors.map((d: any) => (
                  <Option key={d.id} value={d.id}>
                    {d.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={3}>
            {insuranceArray && insuranceArray.length !== 0 && (
              <Form.Item name='yidibz' initialValue='all'>
                <Select placeholder='医保险种'>
                  <Option value='all' key='all'>
                    全部
                  </Option>
                  <Option value={0} key={0}>
                    本地
                  </Option>
                  <Option value={3} key={3}>
                    省医保
                  </Option>
                </Select>
              </Form.Item>
            )}
          </Col>
          <Col flex='auto'>
            <div style={{ display: 'flex', gap: '12px' }}>
              <DateSelect
                style={{ width: '8.5rem' }}
                labelPrefix=''
                rangeType={true}
                allowClear={false}
                namePrefix='time'
                options={TJFXTime}
                placeholder='时间'
                initialValue={DateRangeType.ThisMonth}
                defaultTimeFlag={true}
              />
              <Button htmlType='submit' type='primary' loading={loading}>
                查询
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
      <div style={{ marginTop: 16 }}>
        <Table
          columns={columns}
          dataSource={tableData}
          loading={loading}
          rowKey={(record, index) => `${record.paymentTime}_${index}`}
          scroll={{ y: 500 }}
          pagination={{
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条`,
          }}
        />
      </div>
    </div>
  )
}
